import React, { useEffect, useRef, useState } from 'react';
import { StyledIndustriesIframeBlock } from './StyledIndustriesIframeBlock';
import { useHistory } from 'react-router-dom'
import { useDispatch } from "react-redux";
import gsap from 'gsap';
import {
  setLoader,
} from "../../redux/loader/loader.actions";

const IndustriesIframeBlock = ({ title, text, black, url, bgColor, route, zoom, mobileSrc, isLanding, iframeUrl }) => {
  const [resizeHeight, setResizeHeight] = useState(null)
  const [resizeWidth, setResizeWidth] = useState(null)
  const iframeRef = useRef(null);
  let history = useHistory();
  const dispatch = useDispatch();
  const handleCLick = (slug) => {
    
    if(history.location.pathname !== slug){
      dispatch(setLoader(true))
      
      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
  }
  const openOverlay  = (url) => {
    
    if(iframeUrl){
      
      const overlay = document.querySelector('.overlay--zoom')
      
    
        gsap.to(overlay,{x: 0, ease: "power2.easeInOut", duration: .75})
      
    }
    
  }
  const closeOverlay = () =>  {
    
    const overlay = document.querySelector('.overlay--zoom')
    gsap.to(overlay,{x: '-100%', ease: "power2.easeInOut", duration: .75})
  }
  useEffect(() => {
    const resize =  () =>{
      setResizeWidth(window.innerWidth)
      if(window.innerWidth > 1023 && iframeRef.current !== null){
        var newHeight = iframeRef.current.clientWidth * (3/4)
      
        setResizeHeight(newHeight);
      }
      
    }
    window.addEventListener('resize', resize)
    if(iframeRef !== null && resizeHeight === null) {
      resize()
    }
    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])
  return (
    <React.Fragment>
      {
       
          <StyledIndustriesIframeBlock isLanding={isLanding}>
            <div className="block--content">
              <div className="block--bg" style={{backgroundColor: bgColor}}></div>
              <div className="block--flex">
                <div className="block--col block--col-iframe" ref={iframeRef}>
                  {
                    resizeWidth > 1023 &&
                    <iframe ref={iframeRef} frameBorder="0" width="100%" height={resizeHeight} src={`https://sketchfab.com/models/${url}/embed?autostart=1&camera=0&transparent=1&ui_animations=0&ui_infos=0&ui_stop=0&ui_inspector=0&ui_watermark_link=0&ui_watermark=0&ui_ar=0&ui_help=0&ui_settings=0&ui_vr=0&ui_fullscreen=0&ui_annotations=0&scrollwheel=0&orbit_constraint_zoom_in=${zoom}`} />
                  }
                  {
                    resizeWidth <= 1023 &&
                    
                    <img src={mobileSrc} onClick={() => {if(iframeUrl) openOverlay()}}/>
                  }
                  {
                    iframeUrl &&
                    <p className="base mobile-tap" onClick={() => openOverlay()}>View</p>
                  }
                </div>
                <div className="block--col block--col-text">
                  <div className="block--text-wrap">
                    <p className="preset-9 block--subtitle" style={{color: black}}>Discover</p>
                    <h4 className="md--title" style={{color: black}}>{title}</h4>
                    <p className="preset-10 block--paragraph" style={{color: black}}>{text}</p>
                    {
                      route &&
                      <div className="cta--primary cursor-cta" onClick={() => handleCLick(route)}>
                        <p className="preset-10 primary-green cursor-cta" style={{color: black}} >Explore</p>
                        <svg width="14" className="next cursor-cta" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path className="cursor-cta"d="M7.66675 10.6673L13.0001 6.00065L7.66675 1.33398" stroke={black} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                          <path className="cursor-cta" d="M13 6H1" stroke={black} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    }
                  </div>
                </div>
              </div>
              {
                isLanding &&
                <div className="overlay--zoom">
                  <div className="close--overlay" onClick={() => closeOverlay()}>
                    <img src={require('../../assets/close-overlay-black.png')} />
                  </div>
                  <iframe src={iframeUrl} />
                </div>
              }
            </div>
            
          </StyledIndustriesIframeBlock>
          
      }
    </React.Fragment>
  );
};

export default IndustriesIframeBlock;
